export default "__VITE_ASSET__Dv6Jqe5f__"